import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { isMaintenanceMode } from "./config/appMode";
import enTranslation from "./translation/en.json";
import bgTranslation from "./translation/bg.json";

const LANG_KEY = "appLanguage";

const savedLanguage = localStorage.getItem(LANG_KEY);
const i18nInstance = isMaintenanceMode ? i18n : i18n.use(Backend);

i18nInstance.use(LanguageDetector).use(initReactI18next).init({
  lng: savedLanguage || "bg",
  fallbackLng: "bg",
  resources: {
    en: { translation: enTranslation },
    bg: { translation: bgTranslation },
  },
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANG_KEY, lng);
});

export default i18n;
